import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistCombineReducers, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import userSlice from './userSlice'
import adminSlice from './adminSlice'
import handleErrorSlice from './handleErrorSlice'
import createSagaMiddleware from 'redux-saga'
import rootSaga from '../sagas'

// Define the persist configuration
const persistConfig = {
  key: 'root',
  storage
}

// Combine persisted reducers and slices
const rootReducer = persistCombineReducers(persistConfig, {
  user: userSlice,
  admin: adminSlice,
  handleError: handleErrorSlice
})

// Create the persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer)

// Create the saga middleware
const sagaMiddleware = createSagaMiddleware()

// Create the Redux store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: { ignoredActions: ['persist/PERSIST'] }
  }).concat(sagaMiddleware)
})

// Create the persistor object
const persistor = persistStore(store)

// Run the root saga
sagaMiddleware.run(rootSaga)

// Export the store and persistor
export { store, persistor }
